import { slideToggle } from "@roghz/slidetoggle";

const searchLinksCurrentButton = document.querySelector(".search-filters button");
const searchLinksList = document.querySelector(".search-filters ul");

searchLinksCurrentButton?.addEventListener("click", async (e) => {
  e.preventDefault();
  if (!e.target.classList.contains('btn-close')) {
    e.target.classList.toggle('active');
  }
  if (e.offsetX > searchLinksCurrentButton.offsetWidth - 40 && e.target.classList.contains('btn-close')) {
    document.querySelector('.help-search-form').submit();
    return false;
  }
  slideToggle(searchLinksList, 500, "flex");
});
